import { v4 as uuidv4 } from 'uuid';
import { appdata } from './internalModules';
import {ScenarioRow} from './internalModules';

export class Scenario {
  className: string
  guid: string
  rows: ScenarioRow[]
  calcMethod: string
  totalArea: number
  isBaseline: boolean //is this scenario marked as the baseline on which to compare other scenarios?

  get gwp(): number {
    let totalGwp = 0
    for (const row of this.rows.values()) {
      totalGwp += row.gwp
    }
    return totalGwp
  }

  get name(): string {
    return `Scenario ${appdata.getScenarioArray().indexOf(this) + 1}`
  }

  constructor() {
    this.className = 'Scenario'
    this.guid = uuidv4();
    this.rows = [];
    this.addRow();
    this.calcMethod = "sqft"
    this.totalArea = 10000;
    this.isBaseline = false
  }

  addRow() {
    this.rows.push(new ScenarioRow(this))
    this.validatePercentages()
  }

  removeLastRow() {
    this.rows.pop()
    this.validatePercentages()
  }

  setRowAmount (rowIndex: number, newAmount: number) {
    let newAmt = newAmount
    if (newAmt < 0){
      newAmt = 0
    }
    this.rows[rowIndex].amount = newAmt
    this.updateTotalArea()
    this.validatePercentages()
  }

  validatePercentages(){
    // for percentage calc, limit to 100% total
    if(this.calcMethod === 'sqft'){
      return
    }
    let sumOfPriorRows = 0
    for (let index = 0; index < this.rows.length; index++) {
      const row = this.rows[index]
      let newRowAmount = row.amount
      if(sumOfPriorRows + Number(newRowAmount) > 100){
        newRowAmount = 100 - sumOfPriorRows
      }
      row.amount = newRowAmount
      if(index === this.rows.length-1 && sumOfPriorRows < 100){
        row.amount = 100 - sumOfPriorRows
      }
      sumOfPriorRows += Number(row.amount)
    }
  }

/*   setLastRowAmount(){
    if(this.calcMethod === 'sqft'){
      return
    }
    let lastRowAmount = 100
    for (let index = 0; index < this.rows.length-1; index++) {
      const row = this.rows[index]
      lastRowAmount -= row.amount
    }
    this.setRowAmount(this.rows.length-1, lastRowAmount)
  } */

  setRowWallTypeId (rowIndex: number, wTypeId: string) {
    this.rows[rowIndex].wTypeId = wTypeId
  }

  setCalcMethod (newCalcMethod: string) {
    if (newCalcMethod !== this.calcMethod) {
      if (newCalcMethod === 'sqft') {
        // % to sqft
        // convert all row amounts to sqft
        for (const row of this.rows.values()) {
          const rowArea = (this.totalArea * row.amount) / 100
          row.amount = rowArea
        }
      }
      if (newCalcMethod === '%') {
        // sqft to %
        // convert all row amounts to % of total area
        for (const row of this.rows.values()) {
          const rowArea = (row.amount / this.totalArea) * 100
          row.amount = rowArea
        }

      }

      this.calcMethod = newCalcMethod;
    }
    this.validatePercentages()
  }

  setTotalArea (newArea: number) {
    this.totalArea = newArea;
  }

  updateTotalArea() {
    if (this.calcMethod === 'sqft') {
      this.totalArea = 0
      for (const row of this.rows.values()) {
        this.totalArea += Number(row.amount)
      }
    }    
  }

  //custom method to convert to json
  toJSON(): object {
    return {
      className: this.className,
      guid: this.guid,
      name: this.name,
      rows: this.rows,
      calcMethod: this.calcMethod,
      totalArea: this.totalArea.toString()
    }
  }


}